import {
  FooterContainer,
  StepTitle,
  WizardContentWrapper,
  FooterSkipButton,
  StyledStepTitleWrapper,
} from "@/components/onboarding/components/welcome-wizard/onboarding-steps.styles";
import type { ImportStepProps } from "./import-types";
import {
  MDSIconButton,
  MDSText,
  MDSTextVariant,
  MDSTextWeight,
  MDSIconKind,
  MDSButton,
  MDSButtonVariant,
} from "@/mds";
import { getFilteredNotesApps } from "./import-steps.config";
import { StepContentWithTabs, StyledStepContentWithTabsContainer } from "./tabs";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";

export const AppleNotesOneClickStepDesktop: React.FC<ImportStepProps> = observer(
  ({ context, handleTabSelect, onSkip, onClose, onNavToStep }) => {
    const { store } = useAppStore();

    const handleContinue = async () => {
      if (context.placement === "onboarding") {
        // For onboarding: navigate to the one-click import step
        onNavToStep?.("apple-notes-one-click");
      } else {
        // For profile menu: use the standalone modal
        onClose?.();
        await store.oneClickImport.startImport("profile_menu");
      }
    };

    const isOnboarding = context.placement === "onboarding";

    const stepContent = (
      <>
        <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
          A system dialog will open with your Apple Notes folder selected. Click &apos;Open&apos; to
          grant Mem access.
        </MDSText>
        {!isOnboarding && (
          <StyledButtonWrapper>
            <MDSButton variant={MDSButtonVariant.Default} onClick={handleContinue}>
              Continue
            </MDSButton>
          </StyledButtonWrapper>
        )}
      </>
    );

    return (
      <WizardContentWrapper>
        <StyledStepTitleWrapper>
          <StepTitle>{isOnboarding ? "Select notes from Apple Notes" : "Import Notes"}</StepTitle>
          {context.placement === "profile-menu" && (
            <MDSIconButton iconKind={MDSIconKind.Exit} onClick={onClose} />
          )}
        </StyledStepTitleWrapper>
        {isOnboarding ? (
          <StyledStepContentWithTabsContainer>{stepContent}</StyledStepContentWithTabsContainer>
        ) : (
          <StepContentWithTabs
            selectedAppId={context?.selectedAppId || null}
            onAppSelect={handleTabSelect}
            tabConfig={{ tabs: getFilteredNotesApps() }}
          >
            {stepContent}
          </StepContentWithTabs>
        )}
        {(onSkip || isOnboarding) && (
          <FooterContainer align="space-between">
            {onSkip && (
              <FooterSkipButton onClick={onSkip} isDisabled={!onSkip}>
                Skip for now
              </FooterSkipButton>
            )}
            {isOnboarding && (
              <MDSButton variant={MDSButtonVariant.Default} onClick={handleContinue}>
                Continue
              </MDSButton>
            )}
          </FooterContainer>
        )}
      </WizardContentWrapper>
    );
  }
);

const StyledButtonWrapper = styled.div`
  display: flex;
  align-self: flex-start;
`;
